import React, { Component } from "react";
import { Redirect } from "react-router-dom";

import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { pink } from "@material-ui/core/colors";
import Container from "@material-ui/core/Container";

import { authenticationService } from "../services";

const errorStyle = {
  color: pink[500]
};

class SignIn extends Component {
  unmount = false;
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      error: "",
      submitted: false,
      loading: false,
      redirect2mainpage: false
    };
    this.login = this.login.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillUnmount() {
    this.unmount = true;
  }

  componentDidMount() { }

  login(event) {
    event.preventDefault();
    const { username, password } = this.state;

    console.log(username, password);

    this.setState({ submitted: true });
    if (!(username && password)) {
      return;
    }

    this.setState({ loading: true });
    authenticationService.login(username, password, this).then(
      function () {
        if (!this.unmount) this.setState({ loading: false });
      }.bind(this)
    );
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  render() {
    const { username, password, error, loading, submitted } = this.state;

    if (this.state.redirect2mainpage) {
      return <Redirect to="/mainpage" />;
    }
    return (
      <Container component="main" maxWidth="xs" style={{ marginTop: 100 }}>
        <CssBaseline />
        <div>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          {error &&
            error.response &&
            error.response.data.error.statusCode === 404 && (
              <div style={errorStyle}>Username doesn't exist</div>
            )}
          {error &&
            error.response &&
            error.response.data.error.statusCode === 401 && (
              <div style={errorStyle}>Password is incorrect</div>
            )}
          {error &&
            error.response &&
            error.response.data.error.statusCode === 422 && (
              <div cstyle={errorStyle}>Username or Password is invalid</div>
            )}
          {error && error.message && (
            <div style={errorStyle}>{error.message}</div>
          )}
          <form noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="username"
              label="Username"
              name="username"
              autoComplete="username"
              autoFocus
              value={username}
              onChange={this.handleChange}
            />
            {submitted && !username && (
              <div className="alert alert-danger">Username is required</div>
            )}
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              value={password}
              onChange={this.handleChange}
            />
            {submitted && !password && (
              <div className="alert alert-danger">Password is required</div>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              onClick={this.login}
              disabled={loading}
            >
              Sign In
            </Button>
          </form>
        </div>
      </Container>
    );
  }
}

export { SignIn };
